
import { AuthPagesConfig } from '../@WUM/templates/default/Auth/modules'

const components = {
    AuthPagesConfig: AuthPagesConfig,
}

export default components
